'use client';

import Container from '../../../components/Container';
import CleanButton from '../../../components/CleanButton/CleanButton';
import HeroImage from '../../../assets/HeroSectionSlika.png';

const HeroSection = () => {
  const handleTryApp = () => {
    window.open(
      'https://app.quartermaster.io',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const handleGitHub = () => {
    window.open(
      'https://github.com/quartermaster-io',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <Container size="lg">
      <div className="row align-items-center py-5">
        <div className="col-md-8 mx-auto mb-4 mb-lg-0">
          <h1 className="display-3 fw-bold mb-4 text-center pt-5">
            Build for AI <span className="text-gradient">Agents</span>
          </h1>
          <p className="lead mb-4 text-muted text-center">
            Turn your ideas into ready-to-use AI agents in minutes. No coding,
            no infrastructure headaches just drag, drop & run.
          </p>
          <div className="d-flex gap-3 mb-4 justify-content-center flex-wrap">
            <CleanButton variant="primary" size="lg" onClick={handleTryApp}>
              <i className="bi bi-rocket-takeoff me-2"></i>
              Apply to Waitlist
            </CleanButton>
          </div>
        </div>

        <div className="col-md-12 text-center">
          <img
            src={HeroImage}
            alt="AI Agent Management Dashboard"
            className="img-fluid rounded shadow-lg"
          />
          <div className="d-flex flex-wrap justify-content-center gap-4 mt-4">
            <div className="d-flex align-items-center text-muted small">
              <i className="bi bi-check-circle-fill text-success me-2"></i>
              Launch fast
            </div>
            <div className="d-flex align-items-center text-muted small">
              <i className="bi bi-check-circle-fill text-success me-2"></i>
              Enterprise secure
            </div>
            <div className="d-flex align-items-center text-muted small">
              <i className="bi bi-check-circle-fill text-success me-2"></i>
              Developer-friendly
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HeroSection;
